import { Box, BoxProps } from "@xcorejs/ui";

const RobeLoader = (props: BoxProps) => {
  return <Box as="object" type="image/svg+xml" data="/static/loader.svg" width="192px" {...(props as any)} />;
};

export default RobeLoader;
